<script setup>
import { Bars3Icon } from "@heroicons/vue/24/solid/index.js";
import NavItems from "@/Components/Navigation/NavItems.vue";
import { XMarkIcon } from "@heroicons/vue/24/solid/index.js";
import { ref } from "vue";

const emit = defineEmits(["close"]);

const showNav = ref(false);

//default value for page reload
document.getElementById("body").style.overflow = "auto";
function show() {
    showNav.value = true;
    document.getElementById("body").style.overflow = "hidden";
}
function hide() {
    showNav.value = false;
    document.getElementById("body").style.overflow = "auto";
}
</script>

<template>
    <div class="xl:hidden flex items-center">
        <button class="rounded-xl p-2 hover:bg-gray-50 transition-colors" @click="show" v-if="showNav === false">
            <Bars3Icon class="w-8 h-8 text-theme-primary" />
        </button>
        <button class="rounded-xl p-2 hover:bg-gray-50 transition-colors" @click="hide" v-else>
            <XMarkIcon class="w-8 h-8 text-theme-primary" />
        </button>
    </div>

    <transition>
        <div
            class="fixed top-[72px] left-0 right-0 z-[60] h-[calc(100dvh-72px)] overflow-y-auto border-t border-gray-200 bg-white shadow-2xl"
            v-if="showNav"
        >
            <nav class="min-h-full bg-white px-4 py-5">
                <ul class="flex flex-col gap-2 text-lg font-bold text-gray-700">
                    <NavItems mobile />
                </ul>
            </nav>
        </div>
    </transition>
</template>

<style scoped></style>
